import React from "react";
import Avatar from "components/Avatar";
import { useTranslation } from "react-i18next";
import { EmployeeLink } from "components/Employees/EmployeeEditDrawer";


const getPlanHeader = (props, t) => props.plan_assignments.map((assignment, i) => {
	const employee = assignment.employee;
	const funct =
		employee.employee_with_function &&
			employee.employee_with_function.function
			? employee.employee_with_function.function.name
			: "";
	var text_ubication = "";
	if (employee.employee_with_ubication && employee.employee_with_ubication.ubication) {
		const ubication = employee.employee_with_ubication.ubication;
		text_ubication =
			(<>
				en {ubication.name}
			</>)
	}

	return (
		<th key={i} className="th-employee th-selectable" onClick={() => props.handleRowSelection(i)}>
			<div className="th-wrap-inverted">
				<div className="employee-main">
				<EmployeeLink
					employee={employee}
					className="employee-link-avatar"
					title={t('plan.openProfile')}
					onDrawerClose={props.onEmployeeDrawerClose}
				>
					<Avatar
						userId={employee.id}
						className="avatar-xxs"
						alt={employee.name}
					/>
				</EmployeeLink>
				<div>
					<EmployeeLink
						employee={employee}
						className="employee-link-name substring"
						title={t('plan.openProfile')}
						onDrawerClose={props.onEmployeeDrawerClose}
					>
						{employee.name} {employee.surname}
					</EmployeeLink>
					<span className="employee-info">
						<span className="employee-function substring">{funct}</span>
						<span className="employee-ubication substring">{text_ubication}</span>
					</span>
				</div>
				</div>
			</div>
		</th>
	);
});

const PlanTableHead = (props) => {
	const { t } = useTranslation();
	return (
		<thead>
			<tr>
				<th className="th-day th-day-extended"><div className="th-day-content"></div></th>
				{getPlanHeader(props, t)}
			</tr>
		</thead>
	)
};

export default PlanTableHead;
